<template>
  <v-row>
    <v-col>
      <v-form ref='imageForm'>
        <ImageFormAndThumbnail
          ref="imageFormAndThumbnail"
          label-name='画像'
          :requiredImageFile="true"
          @change-image-file="(value) => uploadImageFile = value"
        ></ImageFormAndThumbnail>
      </v-form>
      <v-btn elevation="2" color="primary" @click="uploadImage">
        この記事でのみ使用する
      </v-btn>
      <v-btn
        elevation="2"
        color="blue-grey"
        class="white--text"
        @click="uploadPicture"
      >
        この記事以外でも使用する
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'

export default {
  name: 'ImageDirectUploader',
  components: {
    ImageFormAndThumbnail
  },
  data: function () {
    return {
      uploadImageFile: null,
      errorMessages: []
    }
  },
  methods: {
    uploadImage () {
      if (!this.$refs.imageForm.validate()) return false

      this.$store.dispatch('LoaderStore/displayLoader')
      let formData = new FormData()
      formData.append('download_image[file]', this.uploadImageFile)
      formData.append('download_image[variety]', 'upload')
      axios
        .post('/api/download_images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const downloadImage = data.data.attributes
            this.$emit('upload-download-image', downloadImage)
            const payload = {
              status: 200,
              message: '画像をアップロードしました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.$refs.imageFormAndThumbnail.imageFile = null
            this.$refs.imageFormAndThumbnail.imagePreviewURL = null
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    uploadPicture () {
      if (!this.$refs.imageForm.validate()) return false

      this.$store.dispatch('LoaderStore/displayLoader')
      let formData = new FormData()
      formData.append('picture[name]', this.uploadImageFile.name)
      formData.append('picture[file]', this.uploadImageFile)
      formData.append('picture[is_good]', true)
      formData.append('picture[is_moral]', true)
      axios
        .post('/api/pictures', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const picture = data.data.attributes
            this.$emit('upload-picture', picture)
            const payload = {
              status: 200,
              message: '画像をアップロードしました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.$refs.imageFormAndThumbnail.imageFile = null
            this.$refs.imageFormAndThumbnail.imagePreviewURL = null
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>

<style></style>
